import Page from "webPage/Page";
import MeasuringGuides from "util/MeasuringGuides";

Page.register(['page-template-measuring-guide'], () => {
    let $guides = $('.js-measuring-guide');
    if ($guides.length > 0) {
        $guides.each(function () {
            new MeasuringGuides($(this));
        });
    }
});
